
  // === OpenAI Integration Module ===
  //
  // Sends a user message to openAI and retrieves the response
  // Note that it modifies the messages array, and returns the response
  // TODO consider additional chatGPT parameters, not just temperature
  // autobot param indicates if message completion is expected for assistant or autobot

import {ChatConfig} from "./chatconfig.js";
import {sendSlackMessage, sharedState, slackAndConsole,appendUserMessage, displayError, userSessionIdentifier} from "../shared.js";
console.log("sharedState at import:", sharedState);


var chatBox;
var userInput;
$(document).ready(() => {
  // Wait for the doc to be ready before initializing the chat box
    chatBox = $("#chat-box");
    userInput = $("#user-input");
    // Now `chatBox` refers to the correct element
});

var errorString;

const SUMMARIZATION_TEMPERATURE = 0.9; // Temperature to use when we ask ChatGPT to summarize some text (as opposed to normal dialogue)

const MAX_ALLOWED_TOKENS = 4097 * 4; // Maximum number of tokens allowed in a single chatgpt message
const TOKENS_REQUESTED_FROM_CHAT = 1000; // Tokens requested when we get them all at once
const ANIMATED_TOKENS_COUNT = 25; // Number of tokens to animate at a time
const USERINPUT_HISTORY_LENGTH = 5; // How many user inputs to use for embedding lookup

///
// Constants that have to do with summarization
// Our token counting isn't precisely the same as OpenAI's.  To avoid accidentally going over the limit, we'll leave a buffer of this many tokens 
// TODO Needs careful testing: if it's too low, we'll get errors.  If it's too high, we'll lose too much context
const TOKEN_BUFFER = 850;
const DEBUG = false;
const SHOW_MESSAGES_DURING_400_RETRY = false;
const MAX_TOKENS_DESIRED_AFTER_SUMMARIZATION =
  MAX_ALLOWED_TOKENS - TOKENS_REQUESTED_FROM_CHAT - TOKEN_BUFFER; // Maximum number of tokens we can send in a single message
const NUMBER_OF_MESSAGES_TO_SUMMARIZE_AT_ONCE = 5; // Number of messages to summarize at once 
const INDEX_OF_FIRST_MESSAGE_TO_SUMMARIZE = 2; // Don't summarize or replace the prompt or intake information
var controller;
var parsedLines;

export async function sendMessageForStreamingResponse(messages, autobot) {


  console.log("messages at start of sendMessageForStreamingResponse: " + sharedState.messages);

  controller = new AbortController();
  const signal = controller.signal;


  // TODO needs to move to server, and magic constants change to config params
  let data = JSON.stringify({
    model: "gpt-3.5-turbo-16k",
    messages: messages,
    max_tokens: TOKENS_REQUESTED_FROM_CHAT,
    stream: true, // For streaming responses
    temperature: ChatConfig.temperature,
  });
  /*
  let proxydata = "data=" + data + "&url=" + COMPLETION_URL + "&method=" + "POST" + "&option=" + "openai";
  let headers = {"Content-Type" : "application/x-www-form-urlencoded"};
  */
  const openAIStreamingRequestBody = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${ChatConfig.QUANTELLIA_OPENAI_TOKEN}`,
    },
    body: data,
    signal, // Pass the signal to the fetch request
  };
  processStreamingResponse(openAIStreamingRequestBody, controller, signal, messages, autobot); // ***
}

//
// Handle streaming text response from openAI
//
async function processStreamingResponse(requestBody, controller, signal, messages, autobot) {
  const generate = async () => {

    // TODO: roadmap
    // // Disable the generate button and enable the stop button
    // generateBtn.disabled = true;
    // stopBtn.disabled = false;
    // resultText.innerText = "Generating...";

    try {
      // 
      // Fetch the response from the OpenAI API with the signal from AbortController
      //console.log(`About to fetch from ${COMPLETION_URL} using this request body: ${JSON.stringify(requestBody)}`);
      var sleepLength = 0;
      //var sleepLengthIncrement = 0;
      var response;
      var errorCount;

      // TODO the following constants should go into the config file
      const errorMAX = 5; // How many times to re-attempt to get past the 400 error
      let brutalMessagesLobotomyCount = 3; // In the case of repeated error 400s, lobotomize the messages array to this many strings
      const SUMMARIZATION_LOOP_INCREMENT = 400; // Every time around the loop where we receive a 400 error, summarizing more and more by this increment until it works

      errorCount = 0;
      do {
        errorCount++; // Not sure where this got deleted but got an infinite loop without it
        // 
        // Assess if we need reduce token count if it's too big
        sharedState.totalTokensInMessages = countTokensInArrayOfObjects(messages);
        //
        // Test to see if we're about to request a token count that will go over the limit, thereby generating a 400 error
        // from OpenAI
        //
        // How to think about chat summarization numebers:
        // We have a certain number of tokens allowed to use for the entire chat, which is MAX_ALLOWED_TOKENS
        // We have to keep the total tokens under this number. It is made up of:
        // 1. The tokens in the message array already
        // 2. The token buffer, because our token count isn't always correct
        // 3. The tokens we request from openAI
        //
        // We can't control (2) and (3), but we can use summarization to get the message array to be small enough
        if (sharedState.totalTokensInMessages + TOKEN_BUFFER + TOKENS_REQUESTED_FROM_CHAT > MAX_ALLOWED_TOKENS) {
          let maxMessageTokensDesired =
            MAX_ALLOWED_TOKENS - TOKEN_BUFFER - TOKENS_REQUESTED_FROM_CHAT;
          console.log("Summarizing because of too many tokens: " +
            sharedState.totalTokensInMessages + " tokens in messages, and aiming for " +
            maxMessageTokensDesired + " tokens in messages."
          );
          messages = await reduceMessagesTokenCount(
            messages,
            MAX_ALLOWED_TOKENS - TOKEN_BUFFER - TOKENS_REQUESTED_FROM_CHAT
          );
          requestBody.body = constructOpenAIRequestBody(requestBody.body, messages);

          sharedState.totalTokensInMessages = countTokensInArrayOfObjects(messages);
          console.log(
            "After summarization there are " +
            sharedState.totalTokensInMessages +
            " tokens"
          );
        }
        // TODO get actual token count from this response, and use it instead of artificial (and nonperformant) summarization
        //console.log(`About to fetch from ${COMPLETION_URL} `);
        // XXX REM uncomment next line and comment the other when switching to proxy
        //response = await fetch("streamingProxy.php", requestBody);
        response = await fetch(ChatConfig.COMPLETION_URL, requestBody);

        //console.log(`Got this response from fetch to openAI: ${JSON.stringify(response)}`);
        //console.log(`response.status is: ${response.status}`);

        // If we got an error, then sleep and retry
        if (response.status == 400) {
          // TODO this code as written assumes that the 400 error is due to 
          // a token limitation.  That's not always the case.  Need to parse the
          // error message in more detail, or at least check the token counts and
          // see if they're too high.  Note that our internal token count will not
          // exactly match how many tokens openAI thinks we're sending, which is why
          // this behavior has been the default so far.

          //   console.log(`requestBody that's generating the error 400 is: ${JSON.stringify(requestBody)}`);

          let previousIterationTotalTokensInMessages = sharedState.totalTokensInMessages;
          sharedState.totalTokensInMessages = countTokensInArrayOfObjects(messages);
          if (sharedState.totalTokensInMessages == previousIterationTotalTokensInMessages) {
            // We haven't successfully reduced the tokens, time to abort
            errorCount = errorMAX + 1; // Gets us out of the loop
            console.log(
              "Aborting summarization loop because latest loop iteration didn't change token count from" + sharedState.totalTokensInMessages + " tokens");
          }
          else {
            let maxMessageTokensDesired =
              MAX_ALLOWED_TOKENS - TOKEN_BUFFER - TOKENS_REQUESTED_FROM_CHAT;

            // We'll only retry a limited number of times
            maxMessageTokensDesired -=
              errorCount * SUMMARIZATION_LOOP_INCREMENT;

            console.log(
              "Summarizing (errorcCount: " + errorCount + ") because of error 400, starting with " +
              sharedState.totalTokensInMessages +
              " tokens in messages, and aiming for " +
              maxMessageTokensDesired +
              " tokens in messages"
            );

            messages = await reduceMessagesTokenCount(
              messages,
              maxMessageTokensDesired
            );
            requestBody.body = constructOpenAIRequestBody(requestBody.body, messages);

            //rbSize = countTokensInObject(requestBody);
            sharedState.totalTokensInMessages = countTokensInArrayOfObjects(messages);
            console.log(
              "After summarization there are " +
              sharedState.totalTokensInMessages +
              " tokens"
            );

            // Show user error messages while doing 400 retry
            if (SHOW_MESSAGES_DURING_400_RETRY) {
              if (Math.random() < 0.5)
                botMsg =
                  '<div class="chat-message bot-message"><span class="message-content"> I\'m experiencing some decision fatigue right now, please stand by...</span></div>';
              else if (Math.random() < 0.5)
                botMsg =
                  '<div class="chat-message bot-message"><span class="message-content"> I\'m experiencing some cognitive overload right now, please stand by...</span></div>';
              else
                botMsg =
                  '<div class="chat-message bot-message"><span class="message-content"> Sorry, too many people are asking me to be brilliant right now, and my neural networks are overloaded...please stand by...</span></div>';

              chatBox.append(botMsg);
              chatBox.scrollTop(chatBox.prop("scrollHeight")); // Scroll to display this message
            } else {
              if (errorCount > 1) {
                botMsg =
                  '<div class="chat-message bot-message"><span class="message-content"> Please stand by...</span></div>';
                chatBox.append(botMsg);
                chatBox.scrollTop(chatBox.prop("scrollHeight")); // Scroll to display this message
              }
            }
          }
        }
      } while (response.status == 400 && errorCount < errorMAX);

      //
      // We're through the loop above, and may still not have succeeded, even with with all the retries.
      // In this case, we take extreme measures and remove most of the chat history and try again
      //
      if (response.status != 200 || errorCount >= errorMAX) {
        botMsg =
          '<div class="chat-message bot-message"><span class="message-content" style="color:green"> Could you please ask me that question again?</span></div>';

        chatBox.append(botMsg);
        chatBox.scrollTop(chatBox.prop("scrollHeight")); // Scroll to display this message
        userInput.value = sharedState.globalUserMessage;

        errorString = `Error ${response.status} from OpenAI API: ${response.statusText}`;
        console.error(errorString);

        // Lobotimizing so that we can continue successfully
        console.error("Lobotomizing messages array...");

        messages = messages.slice(0, brutalMessagesLobotomyCount); // Lobotomize the messages array
        requestBody.body = constructOpenAIRequestBody(requestBody.body, messages);
        sharedState.totalTokensInMessages = countTokensInArrayOfObjects(messages);
        console.error(
          "New messages array has " + sharedState.totalTokensInMessages + " tokens"
        );
      } else {
        //
        // Success! We have a response to the openAI request without an error 400. 
        //

        // Create a new readable stream to read the response
        const readableStream = response.body;
        // Read the response as a stream of data
        const reader = readableStream.getReader();
        //const reader = response.body.getReader();
        const decoder = new TextDecoder("utf-8");
        var completeResponseFromChatGPT = "";
        var firstMessage = true; // Flag that says we're outputting the first message in a stream to the console window
        var tempParsing = [];

        // Loop through chunks of tokens from OpenAI, displaying each one until done
        while (true) {
          const { done, value } = await reader.read();

          // The following line is so that we can view tempParsing inside the catch block, below, for error handling
          // The slice is to ensure a shallow copy.
          // let capturedTempParsing = tempParsing.slice(); // Capture the value of tempParsing.

          if (done) {
            break;
          }
          var lines = [];

          //
          // Massage and parse the chunk of data
          //
          const chunk = decoder.decode(value);
          if (chunk) lines = chunk.trim().split("\n\n");
          else {
            slackAndConsole("streaming chunk error #0");
            break;
          }

          //
          // This commented-out section is the old code that was replaced by the code above, which is more robust because it
          // tests operations for legality before doing them.
          // It's preserved here in case we need to revert to it.
          //
          // const parsedLines = lines
          //   .map((line) => line.replace(/^data: /, "").trim()) // Remove the "data: " prefix
          //   .filter((line) => line !== "" && line !== "[DONE]") // Remove empty lines and "[DONE]"
          //   .map((line) => JSON.parse(line)); // Parse the JSON string
          //var tempParsing = lines.map((line) => line.replace(/^data: /, "").trim());
          //var tempParsing = lines.map((line) => line.replace(/data: /g, "").trim()); // TODO will remove data: mid-string too!
          tempParsing = lines.map((line) => line.replace(/data: /g, ""));

          if (tempParsing)
            tempParsing = tempParsing.map((line) => line.trim());
          else {
            slackAndConsole("streaming parsing error #1");
            break;
          }

          if (tempParsing)
            tempParsing = tempParsing.filter(
              (line) => line !== "" && line !== "[DONE]"
            );

          // Remove empty lines and "[DONE]"
          else {
            slackAndConsole("streaming parsing error #2");
            break;
          }

          tempParsing = tempParsing
            .map((line) => {
              try {
                // Sometimes chat completion sends a non-JSON string back; they seem to get truncated, like this example:
                //                 About to try to parse this line:
                // {"id":"chatcmpl-7SZ3MoDjUZNbISoGUjmuOE6HklYmA","object":"chat.completion.chunk","created":1687042284,"model":"gpt-3.5-turbo-0301","choices":[{"delta":{"content":" annual"},"index":0,"f

                // The followinng code maximizes our robustness against this kind of problem by finding the string
                // labeled "content": "<string" and parsing it without assming it's json

                //console.log("About to try to parse this line:\n" + line);
                var parsedLine = checkAndParseJSON(line);
                if (parsedLine == null) {
                  slackAndConsole("Fixing corrupt JSON from OpenAI...\n");
                  if (line != null) {
                    slackAndConsole(`Starting with the string: "${line}"...`);
                    parsedLine = fixCorruptJSONFromOpenAI(line);

                    slackAndConsole("Line is null");
                    parsedLine = "";
                  }
                  slackAndConsole('Repaired string is: "' + parsedLine + '"');
                }
                return parsedLine;
              } catch (error) {
                slackAndConsole(
                  "Error parsing line from streaming console:" +
                  line +
                  error
                );
                return null; // Or any other value that represents an error or an invalid line
              }
            })
            .filter((line) => line !== null);

          if (tempParsing) parsedLines = tempParsing;
          else {
            slackAndConsole("streaming parsing error #3");
            break;
          }

          if (parsedLines)
            for (const parsedLine of parsedLines) {
              const { choices } = parsedLine;

              if (choices) {
                const { delta } = choices[0];
                if (delta) {
                  const { content } = delta;
                  // Update the UI with the new content but NOT if autobot
                  if (content) {
                    completeResponseFromChatGPT += content;
                    if (!autobot) addTextToStreamingChatGPTMessage(content, firstMessage);

                    // Update the messages array with the current completion
                    // We do this because this way ChatGPT will know what it's already said
                    // so it can add to it
                    if (firstMessage) {
                      messages.push({ role: "assistant", content: content });
                      firstMessage = false;
                    } else messages[messages.length - 1].content += content;
                  }
                } // TODO add an else: what to do if it's empty?
              } // TODO add an else: what to do if it's empty?
            }
        }
      }
      // Do processing at end of while loop
      sendSlackMessage(
        `${userSessionIdentifier} said: ${completeResponseFromChatGPT}`
      );
    } catch (error) {
      var innerText; // TODO unused??
      // Handle fetch request errors
      if (signal.aborted) {
        innerText = "Request aborted.";
      } else {
        let errorMessage =
          "Error while generating / processing the streaming response:" +
          error.message;
        slackAndConsole(errorMessage, true);
        innerText = errorMessage;
      }
    } finally {
      // TODO enable these buttons: roadmap
      // Enable the generate button and disable the stop button
      // generateBtn.disabled = false;
      // stopBtn.disabled = true;
      controller = null; // Reset the AbortController instance
      updateUserInput(autobot);
    }
  };

  // roadmap:
  // TODO make a button that calls this function. cool!
  const stopChatCompletion = () => {
    // Abort the fetch request by calling abort() on the AbortController instance
    if (controller) {
      controller.abort();
      controller = null;
    }
  };

  generate();
}

function constructOpenAIRequestBody(body, messages) {
  let ret = body;

  /*
  return JSON.stringify({
  */
}

export function countTokensInArrayOfObjects(arrayOfObjects) {
  let tokenCount = 0;
  if (arrayOfObjects && arrayOfObjects.length > 0) {
    for (let i = 0; i < arrayOfObjects.length; i++) {
      const object = arrayOfObjects[i];

      if (typeof object === "string") {
        const inputString = object.trim();
        const words = inputString.split(/\s+/);
        tokenCount += words.length;
      } else if (typeof object === "object") {
        for (const key in object) {
          if (object.hasOwnProperty(key) && typeof object[key] === "string") {
            const inputString = object[key].trim();
            const words = inputString.split(/\s+/);
            tokenCount += words.length;
          }
        }
      }
    }

    return tokenCount;
  }
}

function checkAndParseJSON(jsonString) {
  try {
    const parsedJSON = JSON.parse(jsonString);
    return parsedJSON;
  } catch (error) {
    return null;
  }
}

function fixCorruptJSONFromOpenAI(line) {
  // Here's an example of a broken string
  // {"id":"chatcmpl-7SZ3MoDjUZNbISoGUjmuOE6HklYmA","object":"chat.completion.chunk","created":1687042284,"model":"gpt-3.5-turbo-0301","choices":[{"delta":{"content":" annual"},"index":0,"f
  // }]} <- for editor matching of braces

  // What we're going to do is to extract the string after "content", if it exists, and return null if it doesn't.  So, in the above example,
  // we'd want to return " annual"

  // Need to test on: Starting with the string: "lta":{"content":" we"},"index":0,"finish_reason":null]"... 

  try {
    // {  <-- for braces matching in editor too
    const contentIndex = line.indexOf('"content":');
    if (contentIndex === -1) {
      return null; // "content" field doesn't exist
    }
    const contentStartIndex = contentIndex + 11; // Index after the closing quote of "content":
    const contentEndIndex = line.indexOf('"}', contentStartIndex); // Index of the closing quote after the content string
    if (contentEndIndex === -1) {
      return null; // Invalid JSON format, closing quote not found
    }
    const contentString = line.substring(contentStartIndex, contentEndIndex);
    return contentString;
  } catch (error) {
    return null;
  }
}

//the user role message, in response to the assistant, is created by the autobot chat
//Also filling the userInput with the autobot response so that the actual user can review it before initiating the next turn
// XXX REM - kinda strange order in which the user input seemingly is set before autobot message is sent.
// This is because sendMessage() is an asynch call but using await sendMessage() is not pausing execution for some reason
// This flow can get cleaned up when the asynch behavior of the calls is fixed
function updateUserInput(autobot) {
  if (autobot == undefined || !autobot) {

    userInput.val("");

    if (ChatConfig.autobot) {

      userInput.val("autobot ..."); // display "temp" text while autbot performs chat completion API call

      ChatConfig.autobotMessages.push({ role: "user", content: messages[messages.length - 1].content }); // get assistant's last message
      sendMessageForStreamingResponse(ChatConfig.autobotMessages, true); // trigger autobot chat to generate response that goes into userInput when we get back here
      // TODO LP need to assess: should we conditionally call sendMessageForNonStreamingResponse here, as we do elsewhere?  I don't 
      // understand the purpose of the autobot yet, but we should assess this when I do.
    }
  }
  else {
    userInput.val(ChatConfig.autobotMessages[ChatConfig.autobotMessages.length - 1].content);
  }
}

// Add the latest few words to the streaming chat message
// TODO this may be a) obsolete and b) should be called animated not streaming (because that's the name I used for a prior mechanism)
function addTextToStreamingChatGPTMessage(chatMessage, firstMessage) {
  if (chatMessage && chatMessage != "")
    chatMessage = chatMessage.replace(/\n/g, "<br>");
  var botMsg = $(
    "#chat-box .chat-message.bot-message:last-child .message-content"
  );
  if (!firstMessage) {
    botMsg.html(botMsg.html() + chatMessage);
  } else {
    botMsg = $(
      '<div class="chat-message bot-message"><span class="message-content">' +
      chatMessage +
      "</span></div>"
    );
    $("#chat-box").append(botMsg);
  }
  // Scroll to the bottom of the chat message
  chatBox.scrollTop(chatBox[0].scrollHeight);
  return chatMessage;
}

// This does not handle display of a CDD when it is requested.  That's covered elsewhere
// This *does* get called when a CDD is displaying on the screen, however
export async function sendMessageAndGetResponse(userMessage) {

  let embeddingsText;

  try {
    // Display the user message in the chat box
    appendUserMessage(userMessage);

    // Add it to the context
    sharedState.messages.push({ role: "user", content: userMessage });

    // TODO: use data back from GPT to get the tokens in the string, not this information
    sharedState.totalTokensInMessages += countTokensInString(userMessage);

    sendSlackMessage(`${userSessionIdentifier}: user said: "${userMessage}"`);

    //console.log("Total tokens so far after purhsing user message : " + sharedState.totalTokensInMessages + " of  " + MAX_TOKENS_DESIRED_AFTER_SUMMARIZATION);

    // // We are displaying the CDD at this time.  Not sure atm what should be any special behavior for this.  Note
    // // that responding to a new cdd, e.g. from /makecdd is handled elsewhere
    // if (askForCDDMode) {
    //   // var CDDInstructionMessage = makeCDDAndCDDInstructionsString();
    //   // Add it to the context
    //   messages.push({ role: "system", content: CDDInstructionsForLLM });

    //   // Trying to get LLM to obey using the following:
    //   userMessagePostCDDInstructions = "Could you please summarize the decision elements in our conversation so far in vis.js JSON format?";
    //   messages.push({ role: "user", content: userMessagePostCDDInstructions }); // TODO if I look at the messages queue, I don't see this in it

    // }
    //else { // Don't ask for a knowledge embedding at the same time we're trying to do CDD generation; that's asking too much of the LLM

    // } for comment matching
    // Get the most recent USERINPUT_HISTORY_LENGTH user messages to use for the expertise lookup. Why: we don't want expertise to use
    // a context-free interation like "tell me more about that please" as the context for the expertise lookup.
    // TODO this could be more efficient, by removing the oldest message from the array each time a new message is added instead of rebuilding it from scratch
    const userMessages = sharedState.messages
      .filter((message) => message.role === "user")
      .map((message) => message.content);

    let recentUserInputs;
    if (userMessages.length > 0) {
      recentUserInputs = userMessages
        .slice(-USERINPUT_HISTORY_LENGTH)
        .join(", ");
    } else {
      recentUserInputs = "";
    }

    // TODO we currently use "askForCDDMode" as a mode that lasts a long time, as long as the CDD is on the screen.  We really
    // need a different flag that says "this current query is about CDD generation", which is the only time we want to turn
    // off the KB.

    if (ChatConfig.KBLOOKUP && !askForCDDMode) {
      // Obtain some helpful extra text from the vector embeddings database
      embeddingsText = ChatConfig.score > 0 ? await getEmbeddingsText(recentUserInputs) : null;

      // Add it to the context
      if (embeddingsText && embeddingsText != "") {
        sharedState.messages.push({ role: "system", content: embeddingsText });
        sharedState.totalTokensInMessages += countTokensInString(embeddingsText);
        //console.log("Total tokens so far after pushing expert message : " + sharedState.totalTokensInMessages + " of  " + MAX_TOKENS_DESIRED_AFTER_SUMMARIZATION);
        // Send the message to openAI and process the response
      }
      // { for matching
      //}
    }

    // Send this information so far to openAI so it can greet the user
    // Note that it updates the messages context based on the response, and returns
    // it as shown. 

    // Note that the awaits on the sendMessages below are because we might ask for a CDD, and we don't
    // want the response from that stream to get mixed up in this stream; they need to be separated in time
    // TODO need to duplicate the above comment in other places we do this
    if (!ChatConfig.TESTINGSKIPLLMINVOCATION) {
      //if (ChatConfig.streamingMode && !askForCDDMode) // flag test because we still want to stream if a cdd is on the screen
      if (ChatConfig.streamingMode)
        await sendMessageForStreamingResponse(sharedState.messages);
      else await sendMessageForNonStreamingResponse(sharedState.messages);
    }

    if (ChatConfig.SUMMARIZATION && !askForCDDMode) {
    // Summarize the messages if they've gotten too long
    // Note that I'm doing this *after* the sendMessage call, so that
    // it can happen while the user is reading the message they've seen
    // (not 100% sure that works right with the async, but hopefully)
    //if (sharedState.totalTokensInMessages + TOKENS_REQUESTED_FROM_CHAT >
    //if (sharedState.totalTokensInMessages  // Added the chat tokens so we have room
    // )) for comment matching
    var tokensUsed =
      sharedState.totalTokensInMessages + TOKENS_REQUESTED_FROM_CHAT + TOKEN_BUFFER;
    if (tokensUsed > MAX_ALLOWED_TOKENS) {
      console.log(
        "Summarizing because " +
        tokensUsed +
        " > " +
        MAX_ALLOWED_TOKENS +
        " tokens"
      );

      sharedState.messages = await reduceMessagesTokenCount(
        sharedState.messages,
        MAX_ALLOWED_TOKENS - TOKENS_REQUESTED_FROM_CHAT - TOKEN_BUFFER
      );
      requestBody.body = constructOpenAIRequestBody(requestBody.body, sharedState.messages);

      sharedState.totalTokensInMessages = countTokensInArrayOfObjects(sharedState.messages);

      console.log(
        "Just reduced from " + tokensUsed + " message tokens to " + sharedState.totalTokensInMessages + " tokens"
      );
    }
  }

    // Echo knowledge to slack
    if (ChatConfig.KBTRACKING) {
      if (embeddingsText && embeddingsText !== undefined && embeddingsText !== "") {
        sendSlackMessage(
          "For " +
          userSessionIdentifier +
          ": This knowledge base text was sent along with the above: " +
          embeddingsText +
          ", with score" +
          (scoreArray.length > 1 ? "s: " : ": ") +
          scoreArray.join(", ")
        );
      } /*else 
          sendSlackMessage(
            `${userSessionIdentifier} KB expertise match not close enough in our knowledge base that was a close enough match for this query`
          );*/
    }

  } catch (error) {
    errorString = "Error while getting knowledge base text: " + error + " " + error.stack;
    displayError(errorString);
    console.error(errorString);
  }
}

function countTokensInObject(obj) {
  let count = 0;

  function countTokens(value) {
    if (typeof value === "string") {
      const tokens = value.trim().split(/\s+/);
      count += tokens.length;
    } else if (typeof value === "object" && value !== null) {
      for (const key in value) {
        countTokens(value[key]);
      }
    }
  }

  countTokens(obj);
  return count;
}

// Remove messages from the history array until the total token count
// in the entire chat history is less than maxTokens
// TODO: why does this take messages as a param and then modify sharedState.messages?  Need
// to clean this up 
async function reduceMessagesTokenCount(messages, maxTokensInMessages) {
  console.log(
    "Removing redundant substrings.  Attempting to get to " +
    maxTokensInMessages +
    " tokens."
  );
  /// Remove redundant data in the messages (this usually comes from expertise)
  sharedState.messages = removeRedundantSubstrings(messages);

  sharedState.totalTokensInMessages = countTokensInArrayOfObjects(sharedState.messages);
  console.log(
    "After removing redundant strings, the message token count is " +
    sharedState.totalTokensInMessages
  );

  /// Summarize the earliest messages and replace them into the array, while leaving
  /// the prompt string intact
  let count = 0;
  let loopMax = 10;
  while (
    sharedState.totalTokensInMessages >= maxTokensInMessages &&
    messages.length > 1 &&
    ++count < loopMax
  ) {
    console.log("Summarizing messages, attempt #" + count);

    let firstIndex =
      INDEX_OF_FIRST_MESSAGE_TO_SUMMARIZE +
      (count - 1) * NUMBER_OF_MESSAGES_TO_SUMMARIZE_AT_ONCE;
    let finalIndex =
      INDEX_OF_FIRST_MESSAGE_TO_SUMMARIZE +
      count * NUMBER_OF_MESSAGES_TO_SUMMARIZE_AT_ONCE;
    let maxFinalIndex = messages.length - 1;
    finalIndex = Math.min(finalIndex, maxFinalIndex);
    console.log(
      `Summarizing messages in index positions ${firstIndex} to ${finalIndex}`
    );

    if (firstIndex >= finalIndex) {
      console.log("No more messages to summarize");
      break;
    }

    messages = await summarizeMessagesAndReplaceWithSummary(
      messages,
      firstIndex,
      //NUMBER_OF_MESSAGES_TO_SUMMARIZE_AT_ONCE,
      finalIndex - firstIndex + 1,
      maxTokensInMessages,
      SUMMARIZATION_TEMPERATURE
    );

    sharedState.totalTokensInMessages = countTokensInArrayOfObjects(messages);

    console.log(
      "Finished a round of summarization.  Now the token count is " +
      sharedState.totalTokensInMessages +
      " and our goal count was " +
      maxTokensInMessages
    );
  }

  return messages;
  // TODO need to handle case where we weren't able to reduce the token count enough
}

// Summarize a set of messages
async function summarizeMessagesAndReplaceWithSummary(
  obj,
  startIdx,
  count,
  maxTokens,
  summarizationTemperature
) {
  // Step a: Identify the count array entries starting from index startIdx
  const entries = obj.slice(startIdx, startIdx + count);

  // Step b: Create summary for the entries
  const summary = await createSummary(
    entries,
    maxTokens,
    summarizationTemperature
  );

  // Step c: Replace the count entries with a new assistant entry containing the summary
  const assistantEntry = {
    role: "assistant",
    content: "Summary of messages: " + summary,
  };
  obj.splice(startIdx, count, assistantEntry);

  return obj;
}

function countTokensInString(inputString) {
  // Trim leading and trailing spaces
  inputString = inputString.trim();

  // Split the string into an array of words
  const words = inputString.split(/\s+/);

  // Return the number of words
  return words.length;
}


  async function createSummary(
    messagesToSummarize,
    max_tokens_desired,
    summarizationTemperature
  ) {
    // Step a: Concatenate all messages into a single string
    const contents = messagesToSummarize.map((obj) => obj.content);
    const concatenatedContent = contents.join(" ");

    // Step b: Summarize the concatenated string
    return new Promise((resolve, reject) => {
      // dataToSend = JSON.stringify({
      var dataToSend = JSON.stringify({
        messages: [
          {
            role: "system",
            content: "Please summarize this: " + concatenatedContent,
          },
        ],
        model: "gpt-3.5-turbo-16k", // TODO goes into config
        max_tokens: max_tokens_desired, // TODO Maybe this should be a different ?  Maybe it's the sum of input pus output?****
        temperature: summarizationTemperature,
        //frequency_penalty: 0,
        //presence_penalty: 0,
        //top_p: 0.05,
        //stop: null
        //n: 1,
        //stop: "\n"
      });
      $.ajax({
        url: ChatConfig.COMPLETION_URL, // Works with Quantellia's key
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${ChatConfig.QUANTELLIA_OPENAI_TOKEN}`,
        },
        method: "POST",
        data: dataToSend,
        success: function (response) {
          resolve(response.choices[0]["message"]["content"]);
        },
        error: function (error) {
          console.error(
            "Error sending message to openAI for summarization:" +
            error.responseText
          );
          reject(error.responseText);
        },
      });
    });
  }

  // TODO does this code go somewhere?  this fragment appeared when I was modularizing and I'm worried it belongs somewhere
  // {({ <= for matching
  //     model: "gpt-3.5-turbo-16k",
  //     messages: messages,
  //     max_tokens: TOKENS_REQUESTED_FROM_CHAT,
  //     stream: true, // For streaming responses
  //     temperature: ChatConfig.temperature,
  //   });
  // }